export { default } from './MilitaryRankTwo'
